<template>
  <CustomLineChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    :card-options="cardOptions"
    @reload="getData"
  />
</template>

<script>
import CustomLineChart from '@/components/cards/models/CustomLineChart';
import { mapActions, mapGetters } from 'vuex';
import colors from '@/utils/colors';
import EventBus from '@/utils/event-bus';
import cardsModel from '@/mixins/cards-model';

export default {
  name: 'ProductivityDaily',
  components: {
    CustomLineChart,
  },
  mixins: [
    cardsModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      undefinedLabeL: this.$t('DataManagement.undefined'),
      rawSeries: [],
      filteredValues: [],
      categories: [],
    };
  },
  computed: {
    ...mapGetters('dashboard', [
      'activeDashboardFilters',
      'activeGlobalFilter',
    ]),
    cardOptions() {
      return {
        chart: {
          type: 'areaspline',
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          areaspline: {
            lineColor: colors.componentsColor.seriesLineColor,
            lineWidth: 1,
            fillOpacity: 1,
            fillColor: {
              linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
              stops: [
                [0, colors.componentsColor.seriesAreaColorStart],
                [1, colors.componentsColor.seriesAreaColorEnd],
              ],
            },
            marker: {
              fillColor: colors.componentsColor.seriesLineColor,
              radius: 2,
            },
            dataLabels: {
              enabled: true,
              format: '{y:.2f}%',
            },
          },
        },
        xAxis: {
          type: 'datetime',
        },
        yAxis: {
          labels: {
            formatter() {
              return `${this.value}%`;
            },
          },
        },
        tooltip: {
          pointFormatter() {
            return `<span style="color:${this.color}">\u25CF</span> ${this.series.name}: <b>${parseFloat(this.y.toFixed(2))}%</b><br/>`;
          },
        },
      };
    },
    series() {
      return [{
        data: this.rawSeries.map((serie, index) => ([this.categories[index], serie.productivity])),
        name: 'Produtividade' || this.undefinedLabeL,
      }];
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getCallExportsService',
    ]),
    stringDateToTimestamp(stringDate) {
      const [day, month, year] = stringDate.split('/');
      return new Date(year, month - 1, day).getTime();
    },
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getCallExportsService({
        itemId: this.itemId,
        servicePath: 'getDailyProductivity',
        serviceParams: {
          operatorsIds: this.card.props.filter?.sac_replier?.value.toString(),
        },
      })
        .then((response) => {
          this.rawSeries = response;
          this.requestStatus = 'success';

          if (!response) {
            return;
          }

          this.rawSeries.forEach(({ date, productivity }) => {
            const timestamp = this.stringDateToTimestamp(date);
            this.series[0].data.push(timestamp, productivity);
            this.categories.push(timestamp);
          });

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch((error) => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>
